<template>
  <!-- 电子竞技榜->电子排行榜 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="排列类型">
          <a-select style="width: 150px" v-model="type" @change="qrytype">
            <a-select-option value="1"> 周排行</a-select-option>
            <a-select-option value="2"> 月排行</a-select-option>
            <a-select-option value="3"> 总排行</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="期别" v-if="type !== '3'">
          <a-select
            style="width: 250px"
            v-model="defaultTermsetdata"
            @change="qryListAPI"
          >
            <a-select-option v-for="item in termsetdata" :key="item.ID">
              {{ item.Tname }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="会员账号">
          <a-input v-model="userid" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search()" v-if="role194"
            >搜索</a-button
          >
        </a-form-item>
        <a-form-item v-if="role194">
          <a-tooltip
            placement="topLeft"
            title="请输入完整账号,无法允许馍糊查询!"
            arrow-point-at-center
          >
            <a-button type="primary" @click="searchuser()"
              >单会员全搜索</a-button
            >
          </a-tooltip>
        </a-form-item>
        <a-form-item v-if="role198">
          <a-button type="primary" class="marr10" @click="generateRanking">生成排名</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" class="marr10" @click="showRanking">前端显示排名</a-button>
        </a-form-item>
        <br/>
        <a-form-item label="导出数量">
          <a-input v-model="count" style="width: 150px;" />
        </a-form-item>
        <a-form-item v-if="role196">
          <a-button type="primary" @click="payoutExport()">导出派彩</a-button>
        </a-form-item>
        <a-form-item v-if="role196">
          <a-button type="primary" @click="allExport()">导出全部</a-button>
        </a-form-item>
        <a-form-item v-if="role195">
          <a-button type="primary" class="marr10" @click="showUpload">导入数据</a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      size="middle"
      row-key="ID"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :columns="columns"
      :loading="loading"
      :data-source="data"
      :pagination="false"
      bordered
    >
      <template slot="title">
        <span></span>
        <a-row :gutter="24">
          <a-col :span="6" style="line-height: 30px">排行榜</a-col>
          <a-col style="float: right">
            <template v-if="role197">
              <a-button type="danger" @click="checkDelete()">勾选删除</a-button>
              <a-button type="danger" @click="termDelete()" v-if="type !== '3'"
                >删除本期</a-button
              >
            </template>
            <template v-if="role198">
              <a-button
                type="danger"
                @click="AllTotalDelete()"
                v-if="type === '3'"
                >删除所有</a-button
              >
            </template>
          </a-col>
        </a-row>
      </template>
    </a-table>
    <div style="margin: 16px 0; height: 8px">
      <a-pagination
        style="float: right"
        show-size-changer
        :default-current="pagination.current"
        :total="pagination.total"
        :show-total="(total) => `共 ${total} 条`"
        :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange"
        @showSizeChange="sizeChange"
      />
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="数据导入" @ok="modalOK">
      <div class="box" style="height: 100px">
        <a-button
          type="primary"
          :disabled="fileList.length === 0"
          :loading="uploading"
          @click="handleUpload"
          >开始上传</a-button
        >
        <a-upload
          :file-list="fileList"
          :remove="handleRemove"
          :before-upload="beforeUpload"
        >
          <a-button> <a-icon type="upload" /> 选择文件 </a-button>
        </a-upload>
       <br>
        <a-button type="primary" @click="dowTemplate"> 下载模板 </a-button>
      </div>
    </a-modal>
    

    <!-- 前端显示排名对话框 ------------------------------------->
    <a-modal
      v-model="showRankingModal"
      title="前端显示排名"
      @ok="rankingOk"
    >
      <a-form-model
        ref="ruleForm"
        :model="rankingForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="周排名">
          <a-input-number style="width: 183px" v-model="rankingForm.SlotpvpWeekBet" :min="1" />
        </a-form-model-item>
        <a-form-model-item label="月排名">
          <a-input-number style="width: 183px" v-model="rankingForm.SlotpvpMonthBet" :min="1" />
        </a-form-model-item>
        <a-form-model-item label="总排名">
          <a-input-number style="width: 183px" v-model="rankingForm.SlotpvpTotalBet" :min="1" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
import XLSX from "xlsx";
import { arrayExport } from "../../js/xlsxTool";

export default {
  data() {
    return {
      role194: false, //电子排行榜查询
      role195: false, //电子排行榜上传
      role196: false, //电子排行榜导出
      role197: false, //电子排行榜删除
      role198: false, //电子排行榜生成排名
      data: [],
      columns: [],
      columnsOne: [
        {
          title: "期别",
          dataIndex: "Tname",
          align: "center",
        },
        {
          title: "会员帐号",
          dataIndex: "UserID",
          align: "center",
        },
        {
          title: "投注金额",
          dataIndex: "ValidAmount",
          align: "center",
        },
        {
          title: "排名",
          dataIndex: "Ranking",
          align: "center",
        },
      ],
      columnsTwe: [
        {
          title: "会员帐号",
          dataIndex: "UserID",
          align: "center",
        },
        {
          title: "投注金额",
          dataIndex: "ValidAmount",
          align: "center",
        },
        {
          title: "排名",
          dataIndex: "Ranking",
          align: "center",
        },
      ],
      termsetdata: undefined,
      defaultTermsetdata: undefined,
      userid: undefined,
      type: "1",
      count: 0,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        sizeList: ["10", "20", "30", "40", "50"],
      },
      selectedRowKeys: [],
      loading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      visible: false, //弹框状态
      fileList: [],
      uploading: false,
      showRankingModal:false,
      rankingForm:{},
    };
  },
  methods: {
    // 搜索
    search() {
      this.pagination.current = 1;
      this.qryListAPI();
    },
    //分页页数的改变
    pageNumberChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    //  分页显示条数的变化
    sizeChange(current, size) {
      this.pagination.current = current;
      this.pagination.pageSize = size;
      this.qryListAPI();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 导出全部
    allExport() {
      const that = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出本期排行榜吗？",
        onOk() {
          that.exportData(0);
        },
      });
    },
    // 导出派彩
    payoutExport() {
      const that = this;
      this.$confirm({
        title: "导出",
        content: "确定要导出本期排行榜前" + this.count + "位吗？",
        onOk() {
          if (that.count == "" || that.count == undefined) {
            that.exportData(0);
          } else {
            that.exportData(that.count);
          }
        },
      });
    },
    //导出
    exportData(viptype) {
      let today = new Date();
      this.$message.success(
        "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
      );
      this.axios({
        url: "/slotpvp/exportslotpvpbet",
        method: "get",
        params: {
          UserID: this.userid == undefined ? "" : this.userid,
          TermID: this.defaultTermsetdata,
          Type: this.type,
          Count: viptype,
        },
        responseType: "blob",
      }).then((response) => {
        let blob = new Blob([response.data], { type: response.data.type });
        // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download =
            "电子排行榜- " + today.toISOString().split("T")[0]; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉 blob 对象
        }
      });
    },
    // 下载模板
    dowTemplate() {
      var aoa = [
        ["会员账号", "有效投注"],
        ["ccc", "22"],
      ];
      arrayExport(aoa, "上传模板");
    },
    // 勾选删除
    checkDelete() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.warning("请勾选数据");
        return;
      }
      const that = this;
      this.$confirm({
        title: "批量删除",
        content: "您要确定要删除勾选数据吗？完成后需要手动进行排名!",
        onOk() {
          const idList = [];
          that.selectedRowKeys.forEach((element) => {
            idList.push({ ID: element });
          });

          that.axios
            .post("/slotpvp/deleteslotpvpbet", {
              Type: that.type,
              TermID: 0,
              IDList: idList,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 删除本期
    termDelete() {
      const that = this;
      this.$confirm({
        title: "删除本期",
        content: "您确定要删除本期数据吗？",
        onOk() {
          that.axios
            .post("/slotpvp/deleteslotpvpbet", {
              Type: that.type,
              TermID: that.defaultTermsetdata,
              IDList: [],
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("本期数据删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 删除所有
    AllTotalDelete() {
      const that = this;
      this.$confirm({
        title: "删除所有",
        content: "您确定要删除总排行所有数据吗？",
        onOk() {
          that.axios
            .post("/slotpvp/deleteslotpvpbet", {
              Type: that.type,
              TermID: 0,
              IDList: [],
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("本期数据删除成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 生成排名
    generateRanking() {
      const that = this;
      this.$confirm({
        title: "生成排名",
        content: "您要确定要重新生成排名吗？",
        onOk() {
          that.axios
            .post("/slotpvp/rankingslotpvpbet", {
              Type: that.type,
              TermID: that.defaultTermsetdata,
            })
            .then((res) => {
              if (res.data) {
                that.$message.success("排名成功");
                that.qryListAPI();
              }
            });
        },
      });
    },
    // 显示上传弹框
    showUpload() {
      this.visible = true;
    },
    // 确认上传
    modalOK() {
      this.visible = false;
    },
    isExcel(file) {
      return /\.(xlsx|xls)$/.test(file.name);
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      if (!this.isExcel(file)) {
        this.$message.error("仅支持上传.xlsx、.xls、后缀文件");
        return false;
      }
      this.fileList = [file];
      return false;
    },
    handleUpload() {
      this.uploading = true;
      const that = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const header = that.getHeaderRow(worksheet);
          // 改变头部
          worksheet["A1"].w = "UserID";
          worksheet["B1"].w = "ValidAmount";
          const results = XLSX.utils.sheet_to_json(worksheet);
          this.generateData({ header, results });
          resolve();
        };
        reader.readAsArrayBuffer(that.fileList[0]);
      });
    },
    generateData({ header, results }) {
      //进行上传
      this.uploading = false;
      this.fileList = [];
      this.axios
        .post("/slotpvp/Importslotpvpbet", {
          UserList: results,
          Type: this.type,
          TermID: this.defaultTermsetdata,
        })
        .then((res) => {
          if (res.data) {
            this.mymessage(this, "导入成功");
            this.qryListAPI();
          }
        });
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        let hdr = "UNKNOWN " + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    // 弹框
    showRanking(){
      this.axios
        .post("/receptionset/GetSysSet", {})
        .then((res) => {
          if (res.data) {
            this.rankingForm = res.data[0];
            this.showRankingModal = true;
          }
        });
    },
    //确认设置
    rankingOk(){
      this.axios
        .post("/receptionset/SaveSysSet", {
          Type: 6,
          ID: this.rankingForm.SlotpvpWeekBet,
          Position: this.rankingForm.SlotpvpMonthBet,
          Sort: this.rankingForm.SlotpvpTotalBet,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("设置成功!");
            this.showRankingModal = false;
            this.rankingForm = {};
          }
        });
    },
    // 查询API
    qryListAPI() {
      this.loading = true;
      this.axios
        .post("/slotpvp/getslotpvpbet", {
          UserID: this.userid == undefined ? "" : this.userid,
          TermID: this.defaultTermsetdata,
          Type: this.type,
          pageindex: this.pagination.current,
          pagesize: this.pagination.pageSize,
        })
        .then((res) => {
          if (res.data) {
            this.pagination.total = res.total;
            this.loading = false;
            this.data = res.data;
            this.selectedRowKeys = [];
          }
        });
    },
    // 单会员全搜索
    searchuser() {
      if (this.userid == undefined || this.userid == "") {
        this.$message.warning("会员账号不能得为空");
        return;
      }

      this.pagination.current = 1;
      this.loading = true;
      this.axios
        .post("/slotpvp/getslotpvpbet", {
          UserID: this.userid == undefined ? "" : this.userid,
          TermID: 0,
          Type: this.type,
          pageindex: this.pagination.current,
          pagesize: this.pagination.pageSize,
        })
        .then((res) => {
          if (res.data) {
            this.pagination.total = res.total;
            this.loading = false;
            this.data = res.data;
            this.selectedRowKeys = [];
          }
        });
    },
    // 查询周期
    qrytermset() {
      this.axios
        .post("/slotpvp/getslotpvpterm", { Type: this.type })
        .then((res) => {
          if (res.data) {
            this.termsetdata = res.data;
            this.defaultTermsetdata = res.data[0].ID;
            this.qryListAPI();
          }
        });
    },
    qrytype() {
      if (this.type === "3") {
        this.columns = this.columnsTwe;
        this.qryListAPI();
      } else {
        this.columns = this.columnsOne;
        this.qrytermset();
      }
    },
  },
  //首次加载
  created() {
    this.columns = this.columnsOne;
    this.qrytermset();
    //获取权限
    const array = JSON.parse(sessionStorage.RoleID);
    const roleID = [194, 195, 196, 197, 198];
    var isRole = roleID.filter(function (item) {
      return array.indexOf(item) != -1;
    });
    //功能权限获取
    isRole.forEach((element) => {
      this["role" + element] = true;
    });
  },
};
</script>

<style>
.red {
  color: rgb(255, 0, 0);
}
.marr10 {
  background-color: green !important;
  border-color: green !important;
}
</style>


// WEBPACK FOOTER //
// src/components/slotpvp/leaderboard.vue